import { render, staticRenderFns } from "./TgSwiper.vue?vue&type=template&id=4e3297a4&"
import script from "./TgSwiper.vue?vue&type=script&lang=js&"
export * from "./TgSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports